import { isTimeSeriesSeries, type ReportSeriesPoint } from '@/app/reports/components/report-chart-utils';

export type GroupedSeries = { name: string; values: number[] };

export const hasNamedSeries = (points: ReportSeriesPoint[]): boolean =>
  points.some((point) => Boolean(point.series));

const categoryKey = (point: ReportSeriesPoint, isTime: boolean) =>
  isTime ? point.date : (point.label ?? point.date);

export const collectCategories = (points: ReportSeriesPoint[]): string[] => {
  const isTime = isTimeSeriesSeries(points);
  return [...new Set(points.map((point) => categoryKey(point, isTime)))].sort((a, b) =>
    isTime ? a.localeCompare(b) : 0,
  );
};

export const groupByNamedSeries = (
  points: ReportSeriesPoint[],
  categories: string[],
): GroupedSeries[] => {
  const isTime = isTimeSeriesSeries(points);
  const names = [...new Set(points.map((point) => point.series ?? 'value'))];
  return names.map((name) => ({
    name,
    values: categories.map((category) => {
      const match = points.find(
        (point) => categoryKey(point, isTime) === category && (point.series ?? 'value') === name,
      );
      return match?.value ?? 0;
    }),
  }));
};

export const toSingleSeriesRows = (points: ReportSeriesPoint[]) =>
  points.map((point) => ({
    name: point.label ?? point.date,
    value: point.value,
  }));
